'use strict'

export default function (): void {
  if (document.getElementById('dashboard_filters_sort')) {
    document.getElementById('dashboard_filters_sort')?.addEventListener('change', function () {
      document.getElementById('dashboard_filters_submit')?.click()
    })
  }
}
